export default "__VITE_ASSET__ad573195__"